module.exports = __webpack_public_path__ + "static/delivery-partner-bac80269bff545c10f892232b13d74cd.jpeg";